import { useEffect } from 'react';

import { observer } from 'mobx-react-lite';

import { Stack } from '@components/stack';
import { Text } from '@components/text';

import { getIconForRating, getTextForRating } from 'helpers';

import { Box } from 'components/Box';
import { NamePlate } from 'components/NamePlate';
import { useAuthenticatedUser } from 'features/authentication';
import { useStore } from 'models/Provider';

import {
  ApplicationReviewContainer,
  ApplicationReviewVote,
  ThumbContainer,
  FixedThumbButton,
  NoContent,
  YourReviewContainer,
  ThumbButton,
} from './styles';

export const ApplicationReviews = observer(({ application: detail }) => {
  const { t } = useStore();
  const { reviews } = detail;

  const reviewsToDisplay = reviews.filter((r) => !!r.thumb);

  useEffect(() => {
    detail.setUserRead('ratings');
  }, [detail]);

  return (
    <Box mt="24">
      <Stack space={3}>
        <Text font="bold14" text={t('application.reviews.header.you')} />
        <ReviewVote detail={detail} t={t} />
      </Stack>
      <Box flex justifyContent="space-between" mt="24" mb="8">
        <Text font="bold14" text={t('application.reviews.header.team')} />
        {detail.averageRatingText !== '-' && (
          <Text
            font="regular14"
            color="purple80"
            text={t('application.reviews.average', detail.averageRatingText)}
          />
        )}
      </Box>
      {reviewsToDisplay.length === 0 && <NoContent>{t('application.reviews.nocontent')}</NoContent>}
      {reviewsToDisplay.map((a, i) => (
        <ApplicationReviewContainer key={i} topBorder={i === 0}>
          <NamePlate pic={a.user.picture} name={a.user.displayName} size="lg" />
          <ApplicationReviewVote>
            <FixedThumbButton thumb={a.thumb} active disabled noMargin>
              <ThumbContainer>
                {getIconForRating(a.thumb)}
                <span>{t(getTextForRating(a.doesThink))}</span>
              </ThumbContainer>
            </FixedThumbButton>
          </ApplicationReviewVote>
        </ApplicationReviewContainer>
      ))}
    </Box>
  );
});

const ReviewVote = observer(({ detail, t }) => {
  const me = useAuthenticatedUser();
  const myReview = detail.reviews.find((review) => review.user.id === me.id);

  return (
    <YourReviewContainer>
      <ThumbButton
        thumb="D"
        active={myReview && myReview.doesThink === 'D'}
        onClick={() => detail.setReview('D', me.id)}
      >
        <ThumbContainer>
          {getIconForRating('D')}
          <span>{t('application.rating.defno')}</span>
        </ThumbContainer>
      </ThumbButton>
      <ThumbButton
        thumb="N"
        active={myReview && myReview.doesThink === 'N'}
        onClick={() => detail.setReview('N', me.id)}
      >
        <ThumbContainer>
          {getIconForRating('N')}
          <span>{t('application.rating.no')}</span>
        </ThumbContainer>
      </ThumbButton>
      <ThumbButton
        thumb="Y"
        active={myReview && myReview.doesThink === 'Y'}
        onClick={() => detail.setReview('Y', me.id)}
      >
        <ThumbContainer>
          {getIconForRating('Y')}
          <span>{t('application.rating.yes')}</span>
        </ThumbContainer>
      </ThumbButton>
      <ThumbButton
        noMargin
        thumb="S"
        active={myReview && myReview.doesThink === 'S'}
        onClick={() => detail.setReview('S', me.id)}
      >
        <ThumbContainer>
          {getIconForRating('S')}
          <span>{t('application.rating.strongyes')}</span>
        </ThumbContainer>
      </ThumbButton>
    </YourReviewContainer>
  );
});
